import { DESTINATION_CATEGORIES } from '../constants/travel';

export const getRandomDestination = (category?: keyof typeof DESTINATION_CATEGORIES): string => {
  if (category) {
    const categoryDestinations = DESTINATION_CATEGORIES[category].destinations;
    return categoryDestinations[Math.floor(Math.random() * categoryDestinations.length)];
  } else {
    // Random from all categories
    const allCategories = Object.keys(DESTINATION_CATEGORIES) as (keyof typeof DESTINATION_CATEGORIES)[];
    const randomCategory = allCategories[Math.floor(Math.random() * allCategories.length)];
    return getRandomDestination(randomCategory);
  }
};

export const initializeTripParameters = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const dayAfter = new Date(tomorrow);
  dayAfter.setDate(dayAfter.getDate() + 1);
  
  const formatDate = (date: Date) => {
    return date.toISOString().split('T')[0];
  };

  const startDateStr = formatDate(tomorrow);
  const endDateStr = formatDate(dayAfter);
  
  // Calculate number of full days: (end - start) + 1
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  const timeDiff = endDate.getTime() - startDate.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;

  // Get a random destination from Cultural Explorer category as default
  const culturalDestinations = DESTINATION_CATEGORIES.cultural.destinations;
  const defaultDestination = culturalDestinations[Math.floor(Math.random() * culturalDestinations.length)];

  return {
    destination: defaultDestination,
    startDate: startDateStr,
    endDate: endDateStr,
    budget: 'medium',
    preferredActivityTypes: ['cultural', 'food', 'art'],
    preferredTransportationTypes: ['public_transit', 'walking', 'taxi'],
    numberOfDays: daysDiff,
    additionalInfo: ''
  };
};

export const groupActivitiesByTime = (day: any, activities: any[]) => {
  const groupedActivities: { [key: string]: any[] } = {
    morning: [],
    afternoon: [],
    evening: []
  };

  day.activities?.forEach((activity: any) => {
    const fullActivity = activities?.find((a: any) => a.id === activity.id);
    let timeOfDay = 'morning';
    
    if (fullActivity?.time_of_visit) {
      const timeValue = fullActivity.time_of_visit.toLowerCase().trim();
      if (timeValue.includes('afternoon')) timeOfDay = 'afternoon';
      else if (timeValue.includes('evening') || timeValue.includes('night')) timeOfDay = 'evening';
    }
    
    const activityName = activity.name.toLowerCase();
    if (activityName.includes('breakfast') || activityName.includes('morning')) timeOfDay = 'morning';
    else if (activityName.includes('lunch') || activityName.includes('afternoon')) timeOfDay = 'afternoon';
    else if (activityName.includes('dinner') || activityName.includes('evening') || activityName.includes('night')) timeOfDay = 'evening';
    
    groupedActivities[timeOfDay].push({ ...activity, fullActivity });
  });

  return groupedActivities;
};

export const getTimeIcon = (time: string) => {
  const timeStr = time?.toLowerCase() || '';
  if (timeStr.includes('morning')) return '🌅';
  if (timeStr.includes('afternoon')) return '☀️';
  if (timeStr.includes('evening')) return '🌙';
  return '📍';
};

export const calculateNumberOfDays = (startDate: string, endDate: string): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const timeDiff = end.getTime() - start.getTime();
  return Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
}; 